@if (hasFields) {
  <div
    class="search-filter-content flex-gap-5px flex-space-between flex-row flex-fill">
    <mat-form-field style="margin-top: -1px; min-width: 108px">
      <mat-select [attr.data-testid]="'search_option_select'" [formControl]="dropdownCtrl">
        @for (field of fields; track field; let i = $index) {
          <mat-option [attr.data-testid]="field.templateOptions.label + '_option'"
            [value]="i">
            {{ field.templateOptions.label }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (!displaySearchWithOptions) {
      <form  [formGroup]="form" class="flex-70">
        <div>
          <formly-form [form]="form.at(index)" [model]="model[index]" [fields]="selectedFields[index]"
            [options]="options[index]" (modelChange)="modelChanged($event)">
          </formly-form>
        </div>
      </form>
    }
    @if (displaySearchWithOptions) {
      <form  class="flex-70">
        <mat-form-field style="width: 90%; margin-left: 18px">
          <mat-label>{{searchLabel}}</mat-label>
          <input type="text"
            matInput
            [formControl]="searchForm"
            [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="autoCompleteDisplay">
            @for (option of filteredOptions | async; track option) {
              <mat-option [value]="option">
                {{option.name}}
              </mat-option>
            }
          </mat-autocomplete>
          @if (searchForm.value) {
            <button matSuffix mat-icon-button aria-label="Clear"
              (click)="clearSearchTerm()" [attr.data-testid]="'location_set_close_button'">
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      </form>
    }
    @if (!addDialog) {
      <div  class="flex-7">
        <span></span>
      </div>
    }
    @if (addDialog && (showMenu !== true) && (showAdd$ | async)) {
      <div  class="flex-7">
        <button class="add" [attr.data-testid]="'add_button'" mat-icon-button matTooltip="Create new record"
          (click)="add.emit()">
          <mat-icon>add_circle</mat-icon>
        </button>
      </div>
    }
    @if (showMenu && canAdd) {
      <div>
        <button class="add" [attr.data-testid]="'add_button'" mat-icon-button matTooltip="Create new record"
          (click)="add.emit()" [matMenuTriggerFor]="rightMenu">
          <mat-icon>add_circle</mat-icon>
        </button>
        <mat-menu #rightMenu="matMenu" class="add-revote-menu">
          <ng-template matMenuContent>
            <button mat-menu-item (click)="addStandard.emit()">Add Chick-fil-A, Inc. Standard Restaurants</button>
            <button mat-menu-item (click)="addCaptive.emit()">Add Captive Venues</button>
          </ng-template>
        </mat-menu>
      </div>
    }
  </div>
}
